import { FaFlag, FaSitemap, FaFilePowerpoint, FaFilter } from 'react-icons/fa'
import { PageMenu } from 'components/ideal-core-ui'

const MENU = [
  {
    key: 'steps',
    icon: <FaFlag />,
    text: '5 Simple Steps to Get Started'
  },
  {
    key: 'multipleBids',
    icon: <FaSitemap />,
    text: 'Track Opportunities with Multiple Bids'
  },
  {
    key: 'proposalCreation',
    icon: <FaFilePowerpoint />,
    text: 'Expedite Proposal Creation'
  },
  {
    key: 'pipelineSetup',
    icon: <FaFilter />,
    text: 'Set Up Your Sales Pipeline'
  }
]

const Menu = ({ page, setPage }) => {
  return <PageMenu page={page} setPage={setPage} menu={MENU} />
}

export default Menu
